/**
 * This being a global "loading" indicator. It spans the whole width and height
 * of the app. Used by the `Login` component, for example.
 *
 * Nothing complicated at all. Please keep it this stupid.
 *
 * Animation courtesy of our very own \@nickvoss 🤗
 *
 * NOTE: 👉 DO NOT add a dependency on the GDS JS library (static assets will
 *       have been preloaded so they're OK. Think about *when* this component
 *       is shown. You don't want a loading component to show a separate
 *       loading component as it loads its dependencies. That's
 *       Enterprise™-thinking and we don't do that here (at least not yet).
 */

const Component: React.FC = () => (
  <>
    {/*
      This is not as kudgy as it seems. Avoids:

      1. A CSS artifact from beign emitted by the build process, or
      2. An additional Vite plugin that injects CSS into JS

      TODO: Use CSS Grids.
    */}
    <style type="text/css">
      {`
        @keyframes loading-fade-background {
          0%,
          100% {
            background: var(--bs-danger);
          }
          50% {
            background-color: white;
          }
        }

        @keyframes loading-animation-flip {
          0% {
            transform: rotateY(0deg);
          }
          25% {
            background: var(--bs-danger);
            transform: rotateY(-180deg);
          }
          50% {
            background: var(--gray-s10);
            transform: rotateY(0deg);
          }
        }

        .loading-container {
          background: white;
          width: 10rem;
          height: 10rem;

          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr 1fr 1fr;
          gap: 8px 8px;
          grid-auto-flow: row;
          grid-template-areas:
            "Big Big Big Big"
            "Big Big Big Big"
            "Medium Medium . Smallest"
            "Medium Medium Small Small";
        }

        .loading-tile {
          animation-name: loading-animation-flip;
          animation-duration: 2s;
          animation-iteration-count: infinite;
          background-color: var(--bs-danger);
        }

        .Big {
          grid-area: Big;
          animation-delay: .4s;
        }

        .Medium {
          grid-area: Medium;
          animation-delay: .3s;
        }

        .Small {
          grid-area: Small;
          animation-delay: .2s;
        }

        .Smallest {
          grid-area: Smallest;
          animation-delay: .3s;
        }

        @media (prefers-reduced-motion) {
          .loading-tile {
            animation-name: loading-fade-background;
            border: 1px solid var(--bs-danger);
          }
        }
    `}
    </style>

    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/*
      TODO: Add contact info for when this will inevitably hang. Add a phone
      number, add an email address.
    */}
      <div className="loading-container">
        <div className="loading-tile Big" />
        <div className="loading-tile Medium" />
        <div className="loading-tile Small" />
        <div className="loading-tile Smallest" />
      </div>
    </div>
  </>
);

export default Component;
